import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractNegotiation } from '../../../models/Entities/Contracts/ContractNegotiation';
import { NewContractNegotiation } from '../../../models/Entities/Contracts/NewContractNegotiation';
import { AppState } from '../../../redux/reducers';
import * as ContractNegotiationStore from '../../../redux/middleware/ContractNegotiationMiddleware';

export interface OwnProps {
  contractId: number;
  contractAddendumId: number;
  onNegotiationSelected?: (negotiationId: string | undefined) => void;
}

interface ConnectedProps {
  negotiations: ContractNegotiation[];
  isLoading: boolean;
  errorMessage?: string;
  defaultSponsorId?: number;
}

interface DispatchProps {
  GetContractNegotiationsByAddendumId: typeof ContractNegotiationStore.actionCreators.GetContractNegotiationsByAddendumId;
  CreateContractNegotiation: typeof ContractNegotiationStore.actionCreators.CreateContractNegotiation;
  UpdateContractNegotiation: typeof ContractNegotiationStore.actionCreators.UpdateContractNegotiation;
  DeleteContractNegotiation: typeof ContractNegotiationStore.actionCreators.DeleteContractNegotiation;
}

export type Props = OwnProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: OwnProps): ConnectedProps => {
  const contract: Contract | undefined =
    state.Contract?.list?.find((c: Contract) => c.id === ownProps.contractId);
  const addendum = contract?.addendums?.find((a) => a.id === ownProps.contractAddendumId);

  return {
    negotiations: addendum?.negotiations || [],
    isLoading: addendum?.isGettingContractNegotiations || false,
    errorMessage: addendum?.ErrorGettingContractNegotiations?.ErrorMessage,
    defaultSponsorId:
      (contract?.protocol?.length ?? 0) > 0
        ? contract?.sponsors?.[0]?.sponsorId
        : undefined,
  };
};

export const mapDispatchToProps: DispatchProps = {
  GetContractNegotiationsByAddendumId: ContractNegotiationStore.actionCreators.GetContractNegotiationsByAddendumId,
  CreateContractNegotiation: ContractNegotiationStore.actionCreators.CreateContractNegotiation,
  UpdateContractNegotiation: ContractNegotiationStore.actionCreators.UpdateContractNegotiation,
  DeleteContractNegotiation: ContractNegotiationStore.actionCreators.DeleteContractNegotiation,
};
